module.exports = __webpack_public_path__ + "static/media/DY-Light BG.23e69e6b.svg";